module.exports = __webpack_public_path__ + "img/icono_paso1.e27871bc.png";